module.exports = __webpack_public_path__ + "img/percent.eb2d5a46.png";